module.exports = __webpack_public_path__ + "static/maiacontact-d714f2d01c21b59bb1e02427218538bf.png";